import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { checkAuthAPIHealth, showHealthWarningIfNeeded } from './utils/bootHealthCheck';

// Boot health check - catch auth API miswiring early
checkAuthAPIHealth().then(() => {
  showHealthWarningIfNeeded();
});

// Import JWT auth diagnostics for development
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG_LIVE === 'true') {
  import('./utils/authDiagnosticsJWT');
  
  console.log('🔧 JWT Auth diagnostics loaded - check jwtAuthDiagnostics in console');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);